'use client'
import { createContext, useContext } from 'react'

/**
 * Deliberately free of any router dependency: every shared input reads this, and
 * pulling the URL layer in here would drag it into every form's tests too. Only
 * the provider talks to the URL.
 */
const FieldHighlightContext = createContext('')

export const FieldHighlightContextProvider = FieldHighlightContext.Provider

/** The field the URL is pointing at right now, or '' when there is none. */
export const useHighlightedField = () => useContext(FieldHighlightContext)
